import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({ role, children }) {
  const { loading, isAuthed, role: currentRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-slate-500 text-sm">
        Loading…
      </div>
    );
  }
  if (!isAuthed) {
    const target = role === "admin" ? "/admin" : "/partners";
    return <Navigate to={target} state={{ from: location.pathname }} replace />;
  }
  if (role && currentRole !== role) {
    return <Navigate to={currentRole === "admin" ? "/admin/dashboard" : "/partners/dashboard"} replace />;
  }
  return children;
}
